/** **************************** Import Types ****************************** */
import {
  CREDIT_PACK_REQUEST,
  CREDIT_PACK_SUCCESS,
  CREDIT_PACK_FAILURE,
} from "../types/creditPack.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};

const CreditPackReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREDIT_PACK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREDIT_PACK_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case CREDIT_PACK_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default CreditPackReducer;
